import { getCurrentStateThatSWRShouldReturn } from '../utils'
import isUndefined from 'lodash/isUndefined'

export const name = 'pause'

// This is a SWR middleware for keeping the data even if key changes.
export const pause = (useSWRNext) => {
	return (key, fetcher, config) => {
		// When __bh__apiPaused, SWR is validating if the data is undefined.
		// This is to keep consistent behavior on server-side and client-side.
		const { __bh__apiPaused, bhLocalPaused: localPaused } = config
		const paused = __bh__apiPaused || localPaused

		// currentState use cache or fallback
		const currentState = getCurrentStateThatSWRShouldReturn({ key, config })

		// Actual SWR hook.
		const swr = useSWRNext(paused ? null : key, fetcher, config)

		// use current state data if paused
		return {
			...swr,
			data: paused ? currentState : swr.data,
			isValidating: localPaused ? swr.isValidating : __bh__apiPaused ? isUndefined(currentState) : swr.isValidating,
		}
	}
}
